(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/select-physical-tickets/select-physical-tickets.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/select-physical-tickets/select-physical-tickets.js');
"use strict";

const _React = React,
  useContext = _React.useContext;
const TicketsTable = svs.ticket_partner.sharedComponents.ticketsTable.TicketsTable;
const INFO = svs.ticket_partner.constants.copy.TICKETS_TABLE.INFO;
const UPDATE_ARTICLES = svs.ticket_partner.physicalTickets.actions.UPDATE_ARTICLES;
const _svs$ticket_partner$p = svs.ticket_partner.physicalTickets.constants.FORMS,
  MINIMUM_AMOUNT = _svs$ticket_partner$p.MINIMUM_AMOUNT,
  MINIMUM_AMOUNT_ERROR_MESSAGE = _svs$ticket_partner$p.MINIMUM_AMOUNT_ERROR_MESSAGE;
const SelectPhysicalTickets = _ref => {
  let articles = _ref.articles,
    dispatch = _ref.dispatch;
  const _useContext = useContext(svs.ticket_partner.UserContext),
    isLoggedIn = _useContext.isLoggedIn;
  const handleOnChange = (e, article) => {
    dispatch({
      type: UPDATE_ARTICLES,
      payload: {
        count: e.target.value,
        articleId: article.ticketId,
        price: article.price,
        name: article.ticketTitle
      }
    });
  };
  return React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(TicketsTable, {
    articles: articles,
    cmsArticles: svs.ticket_partner.data.articles.ticketsPhysical,
    handleOnChange: handleOnChange,
    infoMessage: !isLoggedIn ? INFO : '',
    isEditable: true,
    minimumAmount: MINIMUM_AMOUNT,
    minimumAmountErrorMessage: MINIMUM_AMOUNT_ERROR_MESSAGE
  }));
};
svs.ticket_partner.physicalTickets.physicalTicketsForm.selectPhysicalTickets.SelectPhysicalTickets = SelectPhysicalTickets;

 })(window);